import * as React from 'react'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { VestigingEnum, vestigingen } from 'shared/models/Enum'
import SelectieButtonEnum from 'shared/components/SelectieButtonEnum'
import { Loader } from 'shared/components/Loader'
import { IApplicationState } from 'redux/store/store'
import {
  IGetVolumewaardeResponseAction,
  getDataActionCreator,
  postVolumewaardeActionCreator,
  IPostVolumewaardeResponseAction,
  deleteVolumewaardeActionCreator,
  IDeleteVolumewaardeResponseAction,
} from '../../redux/store/actions/volumewaardenAction'
import { IVolumewaardeModel } from 'shared/models/IVolumewaardeModel'
import { Modal, Button } from 'react-bootstrap'

interface IProps {
  requestData: (
    type: string,
    warehouseId: number
  ) => Promise<IGetVolumewaardeResponseAction>
  postData: (
    Volumewaarde: IVolumewaardeModel
  ) => Promise<IPostVolumewaardeResponseAction>
  verwijderData: (
    Volumewaarde: IVolumewaardeModel
  ) => Promise<IDeleteVolumewaardeResponseAction>
  Volumewaarden: IVolumewaardeModel[]
  Volumewaarde: IVolumewaardeModel
  schermloading: boolean
  foutmelding: string
  type: string
  globalVestiging: VestigingEnum
}

const VolumewaardenLijst: React.FunctionComponent<IProps> = ({
  type = undefined,
  requestData,
  postData,
  verwijderData,
  schermloading,
  foutmelding,
  Volumewaarden,
  Volumewaarde = undefined,
  globalVestiging,
}) => {
  React.useEffect(() => {
    requestData(type, globalVestiging.valueOf())
  }, [])
  const [show, setShow] = React.useState(false)
  const [opgeslagen, setOpgeslagen] = React.useState(false)
  const [huidigeVolumewaarde, setVolumewaarde] = React.useState(Volumewaarde)
  const [typeOmschrijving, setHuidigeOmschrijving] = React.useState('')
  const [selectedWarehouse, setSelectedWarehouse] =
    React.useState(globalVestiging)
  const handleClose = () => {
    setShow(false)
    requestData(type, selectedWarehouse.valueOf())
  }
  const handleShow = () => setShow(true)

  const regex = /[^0-9]/gi

  const renderRows = (data: IVolumewaardeModel[]) => {
    return data.map(x => {
      return (
        <tr key={x.volumewaardeId} onClick={() => showDetail(x)}>
          <td className='tddata'>{x.volumewaardeWaarde}</td>
        </tr>
      )
    })
  }

  const showDetail = (data: IVolumewaardeModel) => {
    console.log('detail...')
    console.log(data)
    setOpgeslagen(false)
    switch (data.volumewaardeTypeCode) {
      case 'D':
        setHuidigeOmschrijving('Diepte')
        break
      case 'B':
        setHuidigeOmschrijving('Breedte')
        break
      case 'S':
        setHuidigeOmschrijving('Hoogte Stapelbaar Fust')
        break
      case 'N':
        setHuidigeOmschrijving('Hoogte Niet Stapelbaar Fust')
        break
    }
    setVolumewaarde(data)
    handleShow()
  }

  const setOmschrijving = e => {
    huidigeVolumewaarde.volumewaardeOmschrijving = e.target.value
  }

  const setWaarde = e => {
    e.target.value = e.target.value.replace(regex, '')
    huidigeVolumewaarde.volumewaardeWaarde = +e.target.value
  }

  const handleDelete = () => {
    verwijderData(huidigeVolumewaarde).then(handleClose)
  }

  const handleNieuw = (newType: string) => {
    var VolumewaardeNieuw: IVolumewaardeModel = {
      volumewaardeTypeCode: newType,
      volumewaardeId: 0,
      volumewaardeWaarde: undefined,
      volumewaardeOmschrijving: '',
      vestigingCode: +selectedWarehouse,
    }
    showDetail(VolumewaardeNieuw)
  }

  const handleOpslaan = () => {
    setOpgeslagen(true)
    postData(huidigeVolumewaarde)
  }

  const changeWarehouse = (i: VestigingEnum) => {
    setSelectedWarehouse(i)
    requestData(null, i.valueOf())
  }

  return (
    <div>
      <h2>Onderhouden Volumewaarden</h2>

      <div>
        {schermloading && (
          <div>
            <Loader show={true} />
          </div>
        )}
        <table className='selectie'>
          <thead>
            <tr>
              <th className='selectie-label'>Vestiging:</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <SelectieButtonEnum
                  type={VestigingEnum}
                  options={vestigingen}
                  selected={selectedWarehouse}
                  onChange={e => changeWarehouse(e.target.value)}
                />{' '}
              </td>
            </tr>
            <tr>
              <td>
                Gebruik vestiging Geen voor BLO (Buiten Logistiek Om) handel
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {!!foutmelding && (
        <div className='alert alert-danger maxedbox'>{foutmelding}</div>
      )}
      {Volumewaarden != null && (
        <div>
          <table>
            <tbody>
              <tr>
                <td>
                  <h4>Diepte</h4>
                  <table className='selectie'>
                    <tbody>
                      <tr className='tablesubheader'>
                        <th>Waarde</th>
                      </tr>
                      {renderRows(
                        Volumewaarden.filter(s =>
                          s.volumewaardeTypeCode.toString().includes('D')
                        ).sort(function (a, b) {
                          return a.volumewaardeWaarde - b.volumewaardeWaarde
                        })
                      )}
                    </tbody>
                  </table>
                </td>
                <td>
                  <h4>Breedte</h4>
                  <table className='selectie'>
                    <tbody>
                      <tr className='tablesubheader'>
                        <th>Waarde</th>
                      </tr>
                      {renderRows(
                        Volumewaarden.filter(s =>
                          s.volumewaardeTypeCode.toString().includes('B')
                        ).sort(function (a, b) {
                          return a.volumewaardeWaarde - b.volumewaardeWaarde
                        })
                      )}
                    </tbody>
                  </table>
                </td>
                <td>
                  <h4>Hoogte Stapelbaar Fust</h4>
                  <table className='selectie'>
                    <tbody>
                      <tr className='tablesubheader'>
                        <th>Waarde</th>
                      </tr>
                      {renderRows(
                        Volumewaarden.filter(s =>
                          s.volumewaardeTypeCode.toString().includes('S')
                        ).sort(function (a, b) {
                          return a.volumewaardeWaarde - b.volumewaardeWaarde
                        })
                      )}
                    </tbody>
                  </table>
                </td>
                <td>
                  <h4>Hoogte Niet-Stapelbaar Fust</h4>
                  <table className='selectie'>
                    <tbody>
                      <tr className='tablesubheader'>
                        <th>Waarde</th>
                      </tr>
                      {renderRows(
                        Volumewaarden.filter(s =>
                          s.volumewaardeTypeCode.toString().includes('N')
                        ).sort(function (a, b) {
                          return a.volumewaardeWaarde - b.volumewaardeWaarde
                        })
                      )}
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <button
                    className='btn btn-primary'
                    onClick={e => handleNieuw('D')}
                  >
                    Toevoegen Diepte
                  </button>
                </td>
                <td>
                  <button
                    className='btn btn-primary'
                    onClick={e => handleNieuw('B')}
                  >
                    Toevoegen Breedte
                  </button>
                </td>
                <td>
                  <button
                    className='btn btn-primary'
                    onClick={e => handleNieuw('S')}
                  >
                    Toevoegen Hoogte Stapelbaar
                  </button>
                </td>
                <td>
                  <button
                    className='btn btn-primary'
                    onClick={e => handleNieuw('N')}
                  >
                    Toevoegen Hoogte Niet Stapelbaar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            Volumewaarde detail voor vestiging{' '}
            {VestigingEnum[selectedWarehouse]}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!!foutmelding && (
            <div className='alert alert-danger'>{foutmelding}</div>
          )}
          {huidigeVolumewaarde !== undefined && (
            <div>
              <h4>{typeOmschrijving}</h4>
              <table>
                <thead>
                  <tr>
                    <th>Waarde</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='tddata'>
                      <input
                        type='text'
                        maxLength={4}
                        disabled={opgeslagen && foutmelding === ''}
                        defaultValue={huidigeVolumewaarde.volumewaardeWaarde}
                        onChange={e => setWaarde(e)}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {huidigeVolumewaarde !== undefined &&
            huidigeVolumewaarde.volumewaardeId !== 0 &&
            (!opgeslagen || foutmelding !== '') && (
              <Button variant='secondary' onClick={handleDelete}>
                Verwijderen
              </Button>
            )}
          {huidigeVolumewaarde !== undefined &&
            (!opgeslagen || foutmelding !== '') && (
              <Button variant='primary' onClick={handleOpslaan}>
                Opslaan
              </Button>
            )}
          <Button variant='secondary' onClick={handleClose}>
            Sluiten
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    schermloading: store.volumewaardeState.loading,
    Volumewaarden: store.volumewaardeState.volumewaarden,
    foutmelding: store.volumewaardeState.foutmelding,
    globalVestiging: store.globalState.vestiging,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    requestData: (type: string, warehouseId: number) =>
      dispatch(getDataActionCreator(type, warehouseId)),
    postData: (Volumewaarde: IVolumewaardeModel) =>
      dispatch(postVolumewaardeActionCreator(Volumewaarde)),
    verwijderData: (Volumewaarde: IVolumewaardeModel) =>
      dispatch(deleteVolumewaardeActionCreator(Volumewaarde)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VolumewaardenLijst)
